export default __webpack_public_path__ + "static/media/default-hotel-image.2acbf680.svg";